// import React, { useState ,useEffect} from 'react';
// import PropTypes from 'prop-types';
// import CloseButton from '../../common/CloseButton/CloseButton';
// import './UserEditPopup.css';
// import { baseurl } from '../../../api';


// const formatDate = (dateString) => {
//   const date = new Date(dateString);
//   const day = String(date.getDate()).padStart(2, '0');
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const year = date.getFullYear();
//   return `${day}-${month}-${year}`;
// };


// const UserEditPopup = ({
//   isOpen,
//   title,
//   currentLimit,
//   paymentMethod,
//   paymentOptions,
//   onSave,
//   historyData,
//   onClose
// }) => {
//   const [showTable, setShowTable] = useState(false);
//   const [addedUserCount, setAddedUserCount] = useState(0);
//   const [removedUserCount, setRemovedUserCount] = useState(0);
//   const [isSelectOpen, setIsSelectOpen] = useState(false);
//   const [formValues, setFormValues] = useState({
//     payment_method: paymentMethod,
//     count: 0,
//     manage_type: 'No Change'
//   });

//   useEffect(() => {
//     // Reset counts when popup opens
//     setAddedUserCount(0);
//     setRemovedUserCount(0);
//     setFormValues({
//       payment_method: paymentMethod,
//       count: 0,
//       manage_type: 'No Change'
//     });
//   }, [isOpen, paymentMethod]);

//   if (!isOpen) return null;

//   const handleInputChange = (field, value) => {
//     setFormValues(prev => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   const handleIncrement = () => {
//     setAddedUserCount(prev => prev + 1);
//     setFormValues(prev => ({
//       ...prev,
//       count: addedUserCount + 1,
//       manage_type: 'Add'
//     }));
//   };


//   const handleDecrement = () => {
//     // Add validation to prevent removing more users than current limit
//     // This ensures newUserLimit won't go below zero
//     if (currentLimit - (removedUserCount + 1) >= 0) {
//       setRemovedUserCount(prev => prev + 1);
//       setFormValues(prev => ({
//         ...prev,
//         count: removedUserCount + 1,
//         manage_type: 'Remove'
//       }));
//     }
//   };

//   const handleSubmit = () => {
//     if (formValues.manage_type === 'No Change') {
//       onClose();
//       return;
//     }

//     const finalFormValues = {
//       count: formValues.count,
//       payment_method: formValues.payment_method,
//       manage_type: formValues.manage_type
//     };

//     onSave(finalFormValues);
//   };

//   const toggleTable = () => {
//     setShowTable(!showTable);
//   };

//   // Calculate new user limit based on added/removed users
//   const newUserLimit = currentLimit + addedUserCount - removedUserCount;

//   return (
//     <div className="popup-overlay">
//       <div className="popup user-edit-popup popup2">
//         <CloseButton onClick={onClose} />
//         <div className="popup-header">
//           <h2 className="user-edit-title common-text black fts-20 ftw-5">{title}</h2>
//         </div>
//         <div className="popup-body user-limit-fields-container">
//           <div className="field">
//             <p className="common-text left-fields fts-15 ftw-4 black">Current plan user limit</p>
//             <p className="common-text right-values fts-15 ftw-5 black">{currentLimit} Users</p>
//           </div>
//           <div className="field">
//             <p className="common-text left-fields fts-15 ftw-4 black">Manage Users</p>
//             <div className="user-count-controls right-values">
//               <button className="count-btn" onClick={handleDecrement}>-</button>
//               <span className="user-count user-count-span fts-15 ftw-4 black">{newUserLimit}</span>
//               <button className="count-btn" onClick={handleIncrement}>+</button>
//             </div>
//           </div>
//           <div className="field">
//             <p className="common-text left-fields fts-15 ftw-4 black">Payment Method</p>
//             <div className="custom-select-container" onClick={() => setIsSelectOpen(!isSelectOpen)}>
//               <select
//                 className="payment-select"
//                 defaultValue={paymentMethod}
//                 onBlur={() => setIsSelectOpen(false)}
//                 onChange={(e) => handleInputChange('payment_method', e.target.value)}
//               >
//                 {paymentOptions.map((option, index) => (
//                   <option key={index} value={option.value}>{option.label}</option>
//                 ))}
//               </select>
//               <span className={`dropdown-icon ${isSelectOpen ? 'rotate' : ''}`}>
//                 <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
//                   <path d="M4.76975 8.41309L0.0831287 0.295617L9.45637 0.295618L4.76975 8.41309Z" fill="#424242" />
//                 </svg>
//               </span>
//             </div>
//           </div>

//           {/* History Section */}
//           <div className="history-container">
//             <button className="history-button fts-13 ftw-4 common-text dk-gray" onClick={toggleTable}>
//               Add / Remove History
//               <svg
//                 className={`down-svg ${showTable ? 'rotate' : ''}`}
//                 width="26"
//                 height="19"
//                 viewBox="0 0 26 19"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <rect x="25.7017" y="18.4131" width="25" height="18" transform="rotate(180 25.7017 18.4131)" fill="#EBEBEB" />
//                 <path d="M14.0226 15.1828L9.5393 6.95135L18.9096 7.1844L14.0226 15.1828Z" fill="#424242" />
//               </svg>
//             </button>
//             {showTable && (
//               <div className="history-table-container">
//                 <table className="history-table">
//                   <thead className="history-table-head">
//                     <tr className="history-table-tr" style={{ borderBottom: '1px solid #606060' }}>
//                       <th className="common-text fts-12 ly-gray ftw-4">Date</th>
//                       <th className="common-text fts-12 ly-gray ftw-4">Count</th>
//                       <th className="common-text fts-12 ly-gray ftw-4">Bank</th>
//                     </tr>
//                   </thead>
//                   <tbody className="history-tbody">
//                     {historyData?.map((item, index) => (
//                       <tr key={index} className="history-tbody-tr common-text fts-14 black">
//                         <td className="common-text fts-12 ftw-4">
//                           {formatDate(item.date)}
//                         </td>

//                         <td className="common-text fts-12 ftw-4">
//                           <span style={{ color: item.manage_type === 'Add' ? 'green' : 'red' }}>
//                             {item.manage_type === 'Add' ? '+' : '-'}{item.count}
//                           </span>
//                         </td>
//                         <td className="common-text fts-12 black ftw-4">
//                           <span className="user-payment">{item.payment_method}</span>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>
//         </div>

//         <div className="popup-footer">
//           <button 
//             className="apply-button fts-15 ftw-4 common-text" 
//             onClick={handleSubmit}
//             disabled={addedUserCount === 0 && removedUserCount === 0}
//           >
//             Apply Change
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };
// UserEditPopup.propTypes = {
//   isOpen: PropTypes.bool.isRequired,
//   title: PropTypes.string.isRequired,
//   currentLimit: PropTypes.number.isRequired,
//   paymentMethod: PropTypes.string.isRequired,
//   paymentOptions: PropTypes.arrayOf(PropTypes.shape({
//     value: PropTypes.string.isRequired,
//     label: PropTypes.string.isRequired,
//   })).isRequired,
//   onSave: PropTypes.func.isRequired,
//   onClose: PropTypes.func.isRequired,
// };

// export default UserEditPopup;

import React, { useState ,useEffect} from 'react';
import PropTypes from 'prop-types';
import CloseButton from '../../common/CloseButton/CloseButton';
import './UserEditPopup.css';


const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};


const UserEditPopup = ({
  isOpen,
  title,
  currentLimit,
  paymentMethod,
  paymentOptions,
  onSave,
  historyData,
  onClose
}) => {
  const [showTable, setShowTable] = useState(false);
  const [userLimit, setUserLimit] = useState(currentLimit);
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [formValues, setFormValues] = useState({
    payment_method: paymentMethod,
    count: 0,
    manage_type: 'No Change'
  });

  // useEffect(() =>{
  //   console.log("Current",currentLimit)
  // },[currentLimit])


  useEffect(() => {
    if (isOpen) {
      setUserLimit(currentLimit);
      setFormValues({
        payment_method: paymentMethod
      });
    }
  }, [isOpen, currentLimit, paymentMethod]);

  if (!isOpen) return null;

  const handleInputChange = (field, value) => {
    setFormValues(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleIncrement = () => {
    setUserLimit(prev => prev + 1);
  };

  const handleDecrement = () => {
    if (userLimit > 0) {
      setUserLimit(prev => prev - 1);
    }
  };

  const handleSubmit = () => {
    let manage_type = 'No Change';
    if (userLimit > currentLimit) {
      manage_type = 'add';
    } else if (userLimit < currentLimit) {
      manage_type = 'remove';
    }

    if (manage_type === 'No Change') {
      onClose();
      return;
    }

    onSave({
      count: Math.abs(userLimit - currentLimit),
      user_limit: userLimit,
      payment_method: formValues.payment_method,
      manage_type
    });
  };

  const toggleTable = () => {
    setShowTable(!showTable);
  };

  // Calculate new user limit based on added/removed users
  // const newUserLimit = currentLimit + addedUserCount - removedUserCount;

  return (
    <div className="popup-overlay">
      <div className="popup user-edit-popup popup2">
        <CloseButton onClick={onClose} />
        <div className="popup-header">
          <h2 className="user-edit-title common-text black fts-20 ftw-5">{title}</h2>
        </div>
        <div className="popup-body user-limit-fields-container">
          <div className="field">
            <p className="common-text left-fields fts-15 ftw-4 black">Current plan user limit</p>
            <p className="common-text right-values fts-15 ftw-5 black">{currentLimit} Users</p>
          </div>
          <div className="field">
            <p className="common-text left-fields fts-15 ftw-4 black">Manage Users</p>
            <div className="user-count-controls right-values">
              <button className="count-btn" onClick={handleDecrement}>-</button>
              <span className="user-count user-count-span fts-15 ftw-4 black">{userLimit}</span>
              <button className="count-btn" onClick={handleIncrement}>+</button>
            </div>
          </div>
          <div className="field">
            <p className="common-text left-fields fts-15 ftw-4 black">Payment Method</p>
            <div className="custom-select-container" onClick={() => setIsSelectOpen(!isSelectOpen)}>
              <select
                className="payment-select"
                defaultValue={paymentMethod}
                onBlur={() => setIsSelectOpen(false)}
                onChange={(e) => handleInputChange('payment_method', e.target.value)}
              >
                {paymentOptions.map((option, index) => (
                  <option key={index} value={option.value}>{option.label}</option>
                ))}
              </select>
              <span className={`dropdown-icon ${isSelectOpen ? 'rotate' : ''}`}>
                <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.76975 8.41309L0.0831287 0.295617L9.45637 0.295618L4.76975 8.41309Z" fill="#424242" />
                </svg>
              </span>
            </div>
          </div>

          {/* History Section */}
          <div className="history-container">
            <button className="history-button fts-13 ftw-4 common-text dk-gray" onClick={toggleTable}>
              Add / Remove History
              <svg
                className={`down-svg ${showTable ? 'rotate' : ''}`}
                width="26"
                height="19"
                viewBox="0 0 26 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="25.7017" y="18.4131" width="25" height="18" transform="rotate(180 25.7017 18.4131)" fill="#EBEBEB" />
                <path d="M14.0226 15.1828L9.5393 6.95135L18.9096 7.1844L14.0226 15.1828Z" fill="#424242" />
              </svg>
            </button>
            {showTable && (
              <div className="history-table-container">
                <table className="history-table">
                  <thead className="history-table-head">
                    <tr className="history-table-tr" style={{ borderBottom: '1px solid #606060' }}>
                      <th className="common-text fts-12 ly-gray ftw-4">Date</th>
                      <th className="common-text fts-12 ly-gray ftw-4">Count</th>
                      <th className="common-text fts-12 ly-gray ftw-4">Bank</th>
                    </tr>
                  </thead>
                  <tbody className="history-tbody">
                    {historyData?.map((item, index) => (
                      <tr key={index} className="history-tbody-tr common-text fts-14 black">
                        <td className="common-text fts-12 ftw-4">
                          {formatDate(item.date)}
                        </td>

                        <td className="common-text fts-12 ftw-4">
                          <span style={{ color: item.manage_type === 'Add' ? 'green' : 'red' }}>
                            {item.manage_type === 'Add' ? '+' : '-'}{item.count}
                          </span>
                        </td>
                        <td className="common-text fts-12 black ftw-4">
                          <span className="user-payment">{item.payment_method}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        <div className="popup-footer">
          <button 
            className="apply-button fts-15 ftw-4 common-text" 
            onClick={handleSubmit}
            // disabled={addedUserCount === 0 && removedUserCount === 0}
          >
            Apply Change
          </button>
        </div>
      </div>
    </div>
  );
};
UserEditPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  currentLimit: PropTypes.number.isRequired,
  paymentMethod: PropTypes.string.isRequired,
  paymentOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UserEditPopup;
